export default __webpack_public_path__ + "static/media/Word.cf6f65d1.png";